import { render, staticRenderFns } from "./Layanan.vue?vue&type=template&id=16207b9c&scoped=true&"
import script from "./Layanan.vue?vue&type=script&lang=js&"
export * from "./Layanan.vue?vue&type=script&lang=js&"
import style0 from "./Layanan.vue?vue&type=style&index=0&id=16207b9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16207b9c",
  null
  
)

export default component.exports